import { createAppRouter } from '@core/utils/router/create-app-router'
import { routeTree } from '@discover/routeTree.gen'

export const router = createAppRouter(routeTree, ({ pathname, search }) =>
  'card' in search && search.card ? `${pathname}?card=${search.card}` : pathname
)

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
